import { Message, ProfileInfo } from '../../types/default-types'

export interface InfoProps {
  data?: ProfileInfo
  loading: boolean
  init: boolean
  error?: Message[]
}

export const FETCH_INFO_REQUEST = 'FETCH_INFO_REQUEST'
export const FETCH_INFO_SUCCESS = 'FETCH_INFO_SUCCESS'
export const FETCH_INFO_FAILURE = 'FETCH_INFO_FAILURE'
export const INFO_RESET = 'INFO_RESET'

interface Request {
  type: typeof FETCH_INFO_REQUEST
  payload: any
}

interface Success {
  type: typeof FETCH_INFO_SUCCESS
  payload: any
}

interface Failure {
  type: typeof FETCH_INFO_FAILURE
  payload: any
}

interface Reset {
  type: typeof INFO_RESET
  payload: any
}

export type INFO = Request | Success | Failure | Reset
